import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import { App } from "./App";
import { ThemeProvider } from "./lib/theme";
import { queryClient } from "./lib/queryClient";
import { initPostHog, isPostHogEnabled } from "./lib/posthog";
import { PostHogAuthSync } from "./components/PostHogAuthSync";
import "./lib/i18n";
// Self-hosted display typeface for marketing/blog headings (bundled by Vite —
// no external CDN, so it renders identically in dev, CI and prod).
import "@fontsource-variable/bricolage-grotesque";
import "./index.css";

// Init PostHog before React mounts so the very first pageview is captured.
// Client entry only — the SSR/prerender bundle (entry-server.tsx) never
// imports this module.
initPostHog();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            {/* Session-driven identify/reset — only worth the extra session
                fetch on public pages when analytics actually booted. */}
            {isPostHogEnabled() ? <PostHogAuthSync /> : null}
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
